import { createStore } from 'vuex';
import flight from './modules/flight';
import user from './modules/user';
import order from './modules/order';
import file from './modules/file';
import websocket from './modules/websocket';
import chat from './modules/coze';
import auth from './modules/auth';

const protocol = window.location.protocol
const address = process.env.NODE_ENV === 'production' ? 'service.nixiaofeng.com' : 'localhost:3000'
// 使用空字符串作为baseURL，让请求通过代理发送
const baseURL = ''

const store = createStore({
    modules: {
        flight,
        user,
        file,
        websocket,
        order,
        chat,
        auth
    },
    state: {
        address,
        baseURL,
        ip: ''
    },
    mutations: {
        setAddress(state, newAddress) {
            state.address = newAddress;
            state.baseURL = `${protocol}//${newAddress}`;
        },
        setIp(state, newIp) {
            state.ip = newIp;
        },
        removeAddress(state) {
            state.address = '';
            state.baseURL = '';
        },
        removeIp(state) {
            state.ip = '';
        }
    },
    actions: {
        updateAddress({ commit }, newAddress) {
            commit('setAddress', newAddress);
        },
        updateIp({ commit }, newIp) {
            commit('setIp', newIp);
        },
        removeIp({ commit }) {
            commit('removeIp');
        }
    },
    getters: {
        getAddress(state) {
            return state.address;
        },
        getBaseURL(state) {
            return state.baseURL;
        },
        getIp(state) {
            return state.ip;
        }
    },
});

export default store;
